import React, { useEffect, useState } from "react";

import { Autocomplete, TextField } from "@mui/material"
import reduxUtil from "@plannel/utils/redux-util";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import codeUtil from "@plannel/pages/utils/code-util";

const ITEM_TYPE_MAP = codeUtil.itemType;
const ITEM_TYPE_ARRAY = [
  ITEM_TYPE_MAP.KIT.cd,
  ITEM_TYPE_MAP.FG.cd,
  ITEM_TYPE_MAP.SFG.cd,
  ITEM_TYPE_MAP.RM.cd
];

const ITEM_TYPE = {
  KIT: ITEM_TYPE_MAP.KIT.cd,
  FG: ITEM_TYPE_MAP.FG.cd,
  SFG: ITEM_TYPE_MAP.SFG.cd,
  RM: ITEM_TYPE_MAP.RM.cd
}

const ItemTypeFilter = ({ viewName, itemTypeValue, onChangeFilter, itemTypeFilters }) => {
  const { t } = useTranslation();

  const reduxDispatch = useDispatch();
  const [itemTypeFilterDataList, setItemTypeFilterDataList] = useState([]);

  /* ItemType Type 정렬 PLANT -> KIT -> FG -> SFG -> RM */
  const sortItemTypeResults = (itemTypeResults) => {
    const rmItemTypes = [];
    const fgItemTypes = [];
    const sfgItemTypes = [];
    const kitItemTypes = [];

    for (const itemType of itemTypeResults) {
      switch (itemType) {
        case ITEM_TYPE_MAP.KIT.cd:
          kitItemTypes.push(itemType);
          break;
        case ITEM_TYPE_MAP.FG.cd:
          fgItemTypes.push(itemType);
          break;
        case ITEM_TYPE_MAP.SFG.cd:
          sfgItemTypes.push(itemType);
          break;
        case ITEM_TYPE_MAP.RM.cd:
          rmItemTypes.push(itemType);
          break;
        default:
          break;
      }
    }

    return [...kitItemTypes, ...fgItemTypes, ...sfgItemTypes, ...rmItemTypes];
  }

  /* PLANT, CDC, RDC, DC, VENDOR */
  const itemTypeFilter = (results) => {
    let resultsFilter = [];

    if (!isEmpty(itemTypeFilters)) {
      for (const result of results) {
        if (itemTypeFilters.includes(result)) {
          resultsFilter.push(result);
        }
      }
    } else {
      resultsFilter = results;
    }

    return sortItemTypeResults(resultsFilter);
  }

  const onChangeHandler = (_, value) => {
    onChangeFilter(value);

    const createItemTypeReduxState = reduxUtil.createObjectState(viewName, { itemType: value });
    reduxDispatch(reduxUtil.updateViewState(createItemTypeReduxState));
  }

  /* Client에서 정의한 값을 Dropdown List를 하기때문에 전체 Dropdown List값에 대한 Redux 저장이 필요하지 않음.*/
  const getItemTypeData = () => {
      const filterItemTypeList = itemTypeFilter(ITEM_TYPE_ARRAY);
      setItemTypeFilterDataList(filterItemTypeList);
  }

  useEffect(() => {
    getItemTypeData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Autocomplete
      key={"itemType"}
      name={"itemType"}
      options={itemTypeFilterDataList}
      getOptionLabel={option => t(codeUtil.itemType[option].name)}
      value={itemTypeValue}
      onChange={onChangeHandler}
      isOptionEqualToValue={(option, value) => option === value}
      size="small"
      sx={{ minWidth: 230, width: 240, mr: 1 }}
      renderInput={(params) => (
        <TextField {...params} label={t("itemType")} />
      )}
    />
  )
}

export default React.memo(ItemTypeFilter);
export { ITEM_TYPE };